(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
    class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.classList.add('hide');
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.classList.toggle('hide');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
    class ProductModal extends ModalDialog {
        constructor() {
            super();
        }
        hide() {
            super.hide();
        }
        show(opener) {
            super.show(opener);
            this.showActiveMedia();
        }
        showActiveMedia() {
            this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
                element.classList.remove('active');
            })
            const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
            const activeMediaTemplate = activeMedia.querySelector('template');
            const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
            activeMedia.classList.add('active');
            activeMedia.scrollIntoView();
            const container = this.querySelector('[role="document"]');
            container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;
            if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
                activeMedia.loadContent();
            }
        }
    customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["masonry-recipes"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
  // Toggle showing extra bullets
  document.querySelectorAll('.toggle-bullets-button').forEach(button => {
    button.addEventListener('click', function () {
      const recipeContent = button.closest('.recipe-content');
      if (!recipeContent) return;

      const extraItems = recipeContent.querySelectorAll('.extra-bullet');
      let isHidden = false;
      extraItems.forEach(li => {
        if (li.style.display === 'none' || li.style.display === '') {
          isHidden = true;
        }
      });

      extraItems.forEach(li => {
        li.style.display = isHidden ? 'list-item' : 'none';
      });

      button.textContent = isHidden ? 'Show less' : 'View more';
    });
  });

  // Masonry resizing logic
  const grid = document.querySelector('.recipes-masonry');
  function resizeItem(item) {
    const rowHeight = parseFloat(window.getComputedStyle(grid).getPropertyValue('grid-auto-rows'));
    const rowGap = parseFloat(window.getComputedStyle(grid).getPropertyValue('gap'));
    const fullHeight = item.getBoundingClientRect().height;
    const span = Math.ceil((fullHeight + rowGap) / (rowHeight + rowGap));
    item.style.gridRowEnd = "span " + span;
  }
  function resizeAll() {
    document.querySelectorAll('.recipe-card-grid').forEach(item => {
      resizeItem(item);
    });
  }
  window.addEventListener('load', function () {
    resizeAll();
  });
  window.addEventListener('resize', function () {
    resizeAll();
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["partners-logo"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('.carousel-row .carousel-track').forEach(track => {
    track.addEventListener('mouseenter', () => {
      track.style.animationPlayState = 'paused';
    });
    track.addEventListener('mouseleave', () => {
      track.style.animationPlayState = 'running';
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["postum-recipes"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function() {
  if (typeof AOS === 'undefined') {
    var aosScript = document.createElement('script');
    aosScript.src = "https://cdn.jsdelivr.net/npm/aos@2.3.4/dist/aos.js";
    aosScript.onload = () => AOS.init({ duration: 1000, once: true });
    document.head.appendChild(aosScript);

    var aosStyle = document.createElement('link');
    aosStyle.rel = "stylesheet";
    aosStyle.href = "https://cdn.jsdelivr.net/npm/aos@2.3.4/dist/aos.css";
    document.head.appendChild(aosStyle);
  } else {
    AOS.init({ duration: 1000, once: true });
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["story-scroll"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function() {
  // Load AOS if not already loaded
  if (typeof AOS === 'undefined') {
    var aosScript = document.createElement('script');
    aosScript.src = "https://cdn.jsdelivr.net/npm/aos@2.3.4/dist/aos.js";
    aosScript.onload = () => AOS.init({ duration: 1000, once: true });
    document.head.appendChild(aosScript);

    var aosStyle = document.createElement('link');
    aosStyle.rel = "stylesheet";
    aosStyle.href = "https://cdn.jsdelivr.net/npm/aos@2.3.4/dist/aos.css";
    document.head.appendChild(aosStyle);
  } else {
    AOS.init({ duration: 1000, once: true });
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sustainability-carousel"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function() {
  var swiper = new Swiper('.sustainability-swiper', {
    slidesPerView: 3,
    spaceBetween: 24,
    loop: true,
    centeredSlides: false,
    autoplay: {
      delay: 4000,
      disableOnInteraction: false,
    },
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    breakpoints: {
      0: {
        slidesPerView: 1.2,
        centeredSlides: true
      },
      640: {
        slidesPerView: 2,
        centeredSlides: false
      },
      1024: {
        slidesPerView: 3,
        centeredSlides: false
      }
    },
    on: {
      init: function () {
        this.update();
      }
    }
  });
});

  } catch(e) { console.error(e); }
})();
})();
